import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ExternalLink, Quote } from "lucide-react";
import { api } from "@/lib/api";
import { Stars } from "@/components/Reviews";

const GoogleG = () => (
  <svg viewBox="0 0 48 48" className="w-6 h-6" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.5 13.3l7.8 6C12.2 13.4 17.6 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.4 5.7c4.3-4 7.2-9.9 7.2-17.4z" />
    <path fill="#FBBC05" d="M10.3 28.7A14.5 14.5 0 0 1 9.5 24c0-1.6.3-3.2.8-4.7l-7.8-6A24 24 0 0 0 0 24c0 3.9.9 7.5 2.5 10.7l7.8-6z" />
    <path fill="#34A853" d="M24 48c6.2 0 11.6-2 15.4-5.6l-7.4-5.7c-2 1.4-4.7 2.3-8 2.3-6.4 0-11.8-3.9-13.7-9.3l-7.8 6C6.5 42.6 14.6 48 24 48z" />
  </svg>
);

export default function GoogleReviews() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s || !s.google_rating) return null;
  return (
    <div className="mb-12" data-testid="google-reviews-block">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 bg-white border border-ink/10 rounded-2xl p-5" data-testid="google-rating-badge">
        <div className="flex items-center gap-3">
          <GoogleG />
          <div>
            <p className="font-serif text-3xl font-black text-ink leading-none" data-testid="google-rating-value">{Number(s.google_rating).toFixed(1)}</p>
            <Stars n={Math.round(s.google_rating)} size={14} testId="google-rating-stars" />
          </div>
        </div>
        <p className="text-sm text-ink/70 flex-1">Rated by <span className="font-semibold text-ink" data-testid="google-review-count">{s.google_review_count}</span> travellers on Google</p>
        {s.google_reviews_url && (
          <a href={s.google_reviews_url} target="_blank" rel="noreferrer" data-testid="google-reviews-link"
            className="flex items-center gap-1.5 text-sm font-semibold text-ink border border-ink/15 px-4 py-2 rounded-full hover:bg-ink hover:text-sand transition-colors">
            Read on Google <ExternalLink size={13} />
          </a>
        )}
      </div>
      {s.google_reviews?.length > 0 && (
        <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="google-reviews-list">
          {s.google_reviews.slice(0, 6).map((r, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.06 }}
              className="bg-white border border-ink/10 rounded-2xl p-4 flex flex-col" data-testid={`google-review-${i}`}>
              <div className="flex items-center justify-between"><Stars n={r.rating} /> <GoogleG /></div>
              <p className="mt-2 text-sm text-ink/80 leading-relaxed flex-1">{r.text}</p>
              <p className="mt-3 text-xs font-semibold text-ink flex items-center gap-1.5"><Quote size={11} className="text-terra" /> {r.author}{r.date && <span className="text-ink/40 font-normal">· {r.date}</span>}</p>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
